/**
 * Project business rules
 *
 * - Cannot delete project if open work items exist.
 */

/** Work item statuses that count as "closed" (not open). All other statuses are considered open. */
export const CLOSED_WORK_ITEM_STATUSES = ["Done", "Closed", "Resolved"];

function sameProjectName(a, b) {
  const x = (a || "").toString().trim().toLowerCase();
  const y = (b || "").toString().trim().toLowerCase();
  return x && y && x === y;
}

/** Returns true if the project can be deleted (no open work items). When no issues list, treat as no work items → allow delete. */
export function canDeleteProject(project, issuesList = []) {
  if (!project?.projectName) return true;
  const list = Array.isArray(issuesList) ? issuesList : [];
  const openCount = list.filter(
    (issue) =>
      sameProjectName(issue.projectName, project.projectName) &&
      !CLOSED_WORK_ITEM_STATUSES.includes(issue.status)
  ).length;
  return openCount === 0;
}

/** Get count of open work items for a project */
export function getOpenWorkItemsCountForProject(projectName, issuesList = []) {
  if (!projectName || !Array.isArray(issuesList)) return 0;
  return issuesList.filter(
    (issue) =>
      sameProjectName(issue.projectName, projectName) &&
      !CLOSED_WORK_ITEM_STATUSES.includes(issue.status)
  ).length;
}
